var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2377_135858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99901 15.1987C11.9749 15.1987 15.198 11.9756 15.198 7.99975C15.198 4.02387 11.9749 0.800781 7.99901 0.800781C4.02313 0.800781 0.800049 4.02387 0.800049 7.99975C0.800049 11.9756 4.02313 15.1987 7.99901 15.1987Z",
    fill: "url(#paint0_linear_2377_135858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99901 15.1987C11.9749 15.1987 15.198 11.9756 15.198 7.99975C15.198 4.02387 11.9749 0.800781 7.99901 0.800781C4.02313 0.800781 0.800049 4.02387 0.800049 7.99975C0.800049 11.9756 4.02313 15.1987 7.99901 15.1987Z",
    fill: "url(#paint1_linear_2377_135858)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.98453 4.98084L8.21676 4.58066C8.28677 4.46248 8.4005 4.37663 8.53333 4.34167C8.66617 4.30672 8.80743 4.32548 8.92654 4.39389C9.04565 4.4623 9.13303 4.57487 9.16977 4.70722C9.20651 4.83958 9.18965 4.98107 9.12285 5.10109L6.88561 8.9722H8.50289C8.62084 8.98002 8.73502 9.01696 8.8352 9.0797C8.93539 9.14244 9.01847 9.22903 9.077 9.33173C9.13554 9.43442 9.16772 9.55003 9.17065 9.6682C9.17359 9.78638 9.14719 9.90344 9.09382 10.0089H4.35188C4.2783 10.0182 4.20358 10.0118 4.13269 9.99001C4.0618 9.96822 3.99636 9.9316 3.94072 9.88256C3.88508 9.83353 3.84051 9.77321 3.80999 9.70562C3.77946 9.63803 3.76367 9.56472 3.76367 9.49055C3.76367 9.41639 3.77946 9.34308 3.80999 9.27549C3.84051 9.2079 3.88508 9.14758 3.94072 9.09855C3.99636 9.04951 4.0618 9.01289 4.13269 8.9911C4.20358 8.96932 4.2783 8.96287 4.35188 8.9722H5.68095L7.38324 6.0217L6.85244 5.09902C6.81323 5.03951 6.78662 4.97261 6.77422 4.90243C6.76183 4.83226 6.76392 4.76028 6.78037 4.69095C6.79683 4.62161 6.82729 4.55637 6.86989 4.49924C6.91248 4.44211 6.96632 4.39429 7.02808 4.35874C7.08984 4.32318 7.15822 4.30064 7.22902 4.29249C7.29981 4.28434 7.37153 4.29076 7.43975 4.31135C7.50797 4.33194 7.57126 4.36627 7.62573 4.41223C7.68019 4.45819 7.72468 4.5148 7.75645 4.57859L7.98453 4.98084ZM5.98367 10.5459L5.4819 11.4168C5.41261 11.5369 5.29843 11.6246 5.16447 11.6606C5.03051 11.6966 4.88775 11.6779 4.7676 11.6086C4.64744 11.5393 4.55974 11.4251 4.52377 11.2911C4.4878 11.1572 4.50652 11.0144 4.57581 10.8943L4.94695 10.2557C5.12787 10.1851 5.3268 10.1753 5.51379 10.2277C5.70077 10.28 5.86568 10.3917 5.98367 10.5459ZM10.3026 8.97012H11.6587C11.7848 8.98612 11.9009 9.04759 11.985 9.14302C12.0691 9.23845 12.1155 9.36128 12.1155 9.48848C12.1155 9.61568 12.0691 9.73851 11.985 9.83394C11.9009 9.92937 11.7848 9.99085 11.6587 10.0068H10.8936L11.4036 10.888C11.4729 11.0082 11.4916 11.151 11.4557 11.2849C11.4197 11.4189 11.332 11.5331 11.2118 11.6023C11.0917 11.6716 10.9489 11.6904 10.815 11.6544C10.681 11.6184 10.5668 11.5307 10.4975 11.4106C9.6419 9.92459 8.99982 8.81185 8.57131 8.07233C8.40183 7.79923 8.32779 7.47759 8.36082 7.15788C8.39384 6.83816 8.53205 6.53845 8.75378 6.30576C9.0952 6.89323 9.60803 7.77928 10.2923 8.9639L10.3026 8.97012Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2377_135858",
    x1: 7.99901,
    y1: 0.800781,
    x2: 7.99901,
    y2: 15.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3458E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2377_135858",
    x1: 7.99901,
    y1: 0.800781,
    x2: 7.99901,
    y2: 15.2008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78D2F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3458E9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2377_135858"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(0.800049 0.800781)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreLogo);
export default __webpack_public_path__ + "static/media/AppStoreLogo.883dac774c9fc992608e0233264abc28.svg";
export { ForwardRef as ReactComponent };